import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showFeedback: true,
    scroll: 0
  },
  mutations: {
    changeFeedback (state, bool) {
      state.showFeedback = bool
    },
    changeScroll (state, scroll) {
      state.scroll = scroll
    }
  },
  actions: {

  }
})
